import { render, staticRenderFns } from "../templates/normal_fcont_147.html?vue&type=template&id=23b9eec2&scoped=true&"
import script from "./normal_fcont_147.vue?vue&type=script&lang=js&"
export * from "./normal_fcont_147.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b9eec2",
  null
  
)

export default component.exports